module.exports = __webpack_public_path__ + "img/VTH-SmallAnimalEntrance-474x248.035cd65f.jpg";